__turbopack_context__.v({
  "backgroundImageWrap": "zTU3QW_backgroundImageWrap",
  "backgroundLayer": "zTU3QW_backgroundLayer",
  "backgroundOverlay": "zTU3QW_backgroundOverlay",
  "scrollTrack": "zTU3QW_scrollTrack",
  "sectionRoot": "zTU3QW_sectionRoot",
  "solidBackground": "zTU3QW_solidBackground",
  "stickyViewport": "zTU3QW_stickyViewport",
  "text": "zTU3QW_text",
  "word": "zTU3QW_word",
});
